"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useI18nContext = exports.I18nProvider = void 0;
var _react = _interopRequireDefault(require("react"));
var _interpolate = require("./interpolate");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const I18nContext = /*#__PURE__*/_react.default.createContext({
  t: _interpolate.interpolate,
  i18n: {}
});

/**
 * The custom hook to access the `t` function and `i18n` instance of your translation context.
 * @returns
 */
const useI18nContext = () => _react.default.useContext(I18nContext);

/**
 * The helper component to pass your translation functions to the underlying components.
 * @param props
 * @returns
 */
exports.useI18nContext = useI18nContext;
const I18nProvider = _ref => {
  let {
    children,
    ...i18nProps
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(I18nContext.Provider, {
    value: i18nProps
  }, children);
};
exports.I18nProvider = I18nProvider;